<style>

.splash{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("i/splash.jpg");
  background-size: cover;
  padding: 0;
  text-align: center;
}

.logo{
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -23px;
  margin-left: -100px;
  width: 200px;
}

.lower-third{
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
  
  background-image: linear-gradient( rgba(0,0,0,0.2), rgba(0,0,0,1) );
}

.spinner{
  margin-top: 40px;
}
.loading{
  color: rgba(255,255,255,1);
  font-size: 23px;
  /* text-align: center; */
}

.version{
  margin-top: 40px;
  color: rgba(255,255,255,0.5);
  font-size: 14px;
}

</style>

<Auth bind:this="{auth}"></Auth>

{#if $location == "/"}

<div class="splash">
  
  <img src="i/logo.svg" class="logo" alt="logo">
  
  <div class="lower-third">
    <div class="spinner">
      <Spinner spin="{spin}"></Spinner>
    </div>
    
    <div class="loading">
      <AwesomeSauce curMessage="{curMessage}"></AwesomeSauce>
    </div>
    <div class="version">v22.10.08 b169</div>
  </div>
    
</div>

{/if}

<Router {routes}/>

<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

import Dialog from "./components/Dialog.svelte";

import Splash from "./pages/Splash.svelte";
import Invited from "./pages/Invited.svelte";
import SignupPush from "./pages/SignupPush.svelte";
import Signup from "./pages/Signup.svelte";
// import ValidateText from "./pages/ValidateText.svelte";
// import ValidateEmail from "./pages/ValidateEmail.svelte";
import Login from "./pages/Login.svelte";
import Events from "./pages/Events.svelte";
import EventsFilter from "./pages/EventsFilter.svelte";
import EventsInfo from "./pages/EventsInfo.svelte";
import EventsUpcoming from "./pages/EventsUpcoming.svelte";
import EventsPast from "./pages/EventsPast.svelte";
import EditEvent from "./pages/EditEvent.svelte";
// import EditEventImage from "./pages/EditEventImage.svelte";
// import BusinessProfile from "./pages/BusinessProfile.svelte";
import Profile from "./pages/Profile.svelte";
import FindFriends from "./pages/FindFriends.svelte";
import FriendsAll from "./pages/FriendsAll.svelte";
import FriendsIncoming from "./pages/FriendsIncoming.svelte";
import FriendsOutgoing from "./pages/FriendsOutgoing.svelte";
import FriendProfile from "./pages/FriendProfile.svelte";
import Message from "./pages/Message.svelte";
import MessageList from "./pages/MessageList.svelte";
import Notifications from "./pages/Notifications.svelte";
import Search from "./pages/Search.svelte";
import AwesomeSauce from "./components/AwesomeSauce.svelte";
import Spinner from "./components/Spinner.svelte";
// import EventFeedback from "./pages/EventFeedback.svelte";
// import EventFeedback2 from "./pages/EventFeedback2.svelte";

// import test2 from "./pages/test2.svelte";

// import DeleteHelper from "./pages/DeleteHelper.svelte";

// profile builder wizard
import Type from "./pages/wizard/profile/personal/Type.svelte";
import Init from "./pages/wizard/profile/personal/Init.svelte";
import GenerateKeys from "./pages/wizard/profile/personal/GenerateKeys.svelte";
import Name from "./pages/wizard/profile/personal/Name.svelte";
import Email from "./pages/wizard/profile/personal/Email.svelte";
import EmailVerify from "./pages/wizard/profile/personal/EmailVerify.svelte";
import Phone from "./pages/wizard/profile/personal/Phone.svelte";
import PhoneVerify from "./pages/wizard/profile/personal/PhoneVerify.svelte";
import Username from "./pages/wizard/profile/personal/Username.svelte";
import Password from "./pages/wizard/profile/personal/Password.svelte";
import Birthday from "./pages/wizard/profile/personal/Birthday.svelte";
import Gender from "./pages/wizard/profile/personal/Gender.svelte";
import AgePreference from "./pages/wizard/profile/personal/AgePreference.svelte";
import LookingForGender from "./pages/wizard/profile/personal/LookingForGender.svelte";
import DistanceAway from "./pages/wizard/profile/personal/DistanceAway.svelte";
import Photos from "./pages/wizard/profile/personal/Photos.svelte";
import PhotosEdit from "./pages/wizard/profile/personal/PhotosEdit.svelte";
import AddInterests from "./pages/wizard/profile/personal/AddInterests.svelte";
import Questions from "./pages/wizard/profile/personal/Questions.svelte";
import Bio from "./pages/wizard/profile/personal/Bio.svelte";
import SocialLinks from "./pages/wizard/profile/personal/SocialLinks.svelte";
import Location from "./pages/wizard/profile/personal/Location.svelte";
import ThankYou from "./pages/wizard/profile/personal/ThankYou.svelte";

// https://github.com/ItalyPaleAle/svelte-spa-router
import Router from 'svelte-spa-router';
import {push, pop, replace, location} from 'svelte-spa-router';

import Auth from "./interfaces/Auth.svelte";
let auth;

const routes = {
  "/": Splash,
  "/signupask": SignupPush,
  
  "/signup/profile/type": Type,
  "/signup/profile/personal/init": Init,
  "/signup/profile/personal/birthday": Birthday,
  "/signup/profile/personal/name": Name,
  "/signup/profile/personal/email": Email,
  "/signup/profile/personal/email-verify": EmailVerify,
  "/signup/profile/personal/generate-keys": GenerateKeys,
  "/signup/profile/personal/phone": Phone,
  "/signup/profile/personal/phone-verify": PhoneVerify,
  "/signup/profile/personal/username": Username,
  "/signup/profile/personal/password": Password,
  "/signup/profile/personal/gender": Gender,
  "/signup/profile/personal/age-preference": AgePreference,
  "/signup/profile/personal/looking-for": LookingForGender,
  "/signup/profile/personal/distance-away": DistanceAway,
  "/signup/profile/personal/photos": Photos,
  "/signup/profile/personal/photos-edit/:index": PhotosEdit,
  "/signup/profile/personal/add-interests": AddInterests,
  "/signup/profile/personal/questions": Questions,
  "/signup/profile/personal/bio": Bio,
  "/signup/profile/personal/social-links": SocialLinks,
  "/signup/profile/personal/location": Location,
  "/signup/profile/personal/thankyou": ThankYou,
  
  "/invited/:code": Invited,
  "/login": Login,
  // "/delete-helper": DeleteHelper,
  
  "/events": Events,
  "/events/:flag": Events,
  
  "/events-filter": EventsFilter,
  "/events-info/:eid": EventsInfo,
  "/events-upcoming": EventsUpcoming,
  "/events-past": EventsPast,
  "/edit-event/:eid": EditEvent,
  // "/new-event-image": EditEventImage,
  
  // "/business-profile/:bid": BusinessProfile,
  
  "/profile": Profile,
  "/find-friends": FindFriends,
  "/find-friends/:uid": FindFriends,
  "/find-friends/:uid/:sent": FindFriends,
  "/friends-all": FriendsAll,
  "/friends-outgoing": FriendsOutgoing,
  "/friends-incoming": FriendsIncoming,
  "/friend-profile/:fuid": FriendProfile,
  "/message": MessageList,
  "/message/:uid": Message,
  "/notifications": Notifications,
  "/search": Search,
  // "/eventfeedback": EventFeedback, 
  // "/eventfeedback2": EventFeedback2, 
  
  // "/test2": test2, 
  
  // "/": ,
  
  
  // Catch-all
  // This is optional, but if present it must be the last
  // "*": NotFound,
}

export let ready = false;

// for splash updates
let handle = null;
let curMessage = 0;
let signupPush = false;
let loginPush = false;
let readyHandle = null;
let loadedEvents = false;
let loadedPeople = false;
let loadedMessages = false;
let errorMessage = "";

let spin = true;

console.log("v22.10.08 b169");

import { onMount } from "svelte";
onMount(async () => {
  onDeviceReady();
});

// // from https://stackoverflow.com/a/10237209
// if ( navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry)/) && document.URL.indexOf("http://") === -1
//   && document.URL.indexOf("https://") === -1 ) {
//   console.log("on actual mobile device");
//   console.log("navigator.userAgent:", navigator.userAgent);
//   document.addEventListener("deviceready", onDeviceReady, false);
// } else {
//   onDeviceReady();
// }

async function onDeviceReady() {
  ready = true;
  
  if ($location == "/") {
    
    // check if logged in
    setTimeout( () => {loggedIn()}, 0);
    
    // smoothly run loading messages, while everything is loading in the background
    handle = setInterval( () => {
      curMessage++;
      if (curMessage > 3) {
        clearInterval(handle);
      }
    }, 1500);
    
    // actually progress to the next screen when everything is loaded
    readyHandle = setInterval( () => {
      
      if (signupPush == true && curMessage == 4) {
        clearInterval(readyHandle);
        push("/signupask");
      }
      
      if (curMessage == 4 && loadedEvents && loadedPeople && loadedMessages) {
        clearInterval(readyHandle);
        push("/events/all");
      }
      
    }, 500);
    
  }
  
}


function retry() {
  replace("/");
  curMessage = 0;
  onDeviceReady();
}

// checks to see if a user is logged in.
// if so, then we forward the user to the proper page
// otherwise we forward them to the initial system
async function loggedIn() {
  // check log in
  // return; // uncomment to make it stay on the splash screen
  
  // do we have a cookie and csrf?
  let cookie = localStorage.getItem("cookie");
  let csrf = localStorage.getItem("csrf");
  
  if (cookie == null || cookie == "" || csrf == null || csrf == "") {
    try {
      let res = await auth.post("newClient", {}, false);
      
      if (res == "-") {
        return;
      }
      
      let out = JSON.parse(res);
      localStorage.setItem("cookie", out.cookie);
      localStorage.setItem("csrf", out.csrf);
      
    } catch (error) {
      clearInterval(handle);
      clearInterval(readyHandle);
      console.log("newClient error:", error);
      spin = false;
      return;
    }
  }
  
  
  // should we push the user to the signupAsk page or 
  // do we push them straight to events?
  try {
    
    let res = await auth.post("isLoggedIn", {}, false);
    
    if (res == "1") {
      
      // logged in
      setTimeout( () => {getEvents()}, 0);
      
    } else if (res == 0) {
      
      // not logged in
      signupPush = true;
      setTimeout( () => {getLimitedEvents()}, 0);
      
    } else {
      
      // somehow cookie and csrf weren't assigned
      // send them back to the beginning
      console.log("App.svelte no record of cookie and csrf on server:", res);
      spin = false;
      
      localStorage.clear();
      // we could do something different here to make it cleaner, but
      // this is good for now...
      document.location = "/";
    }
    
  } catch (error) {
    clearInterval(handle);
    clearInterval(readyHandle);
    console.log("newClient error:", error);
    spin = false;
    return;
  }
  
}


async function getLimitedEvents() {
  // console.log("getLimitedEvents");
}


async function getEvents() {
  // load current events
  // console.log("load full events and start load people and messages");
  loadedEvents = true;
  setTimeout( () => {getPeople()}, 0);
  setTimeout( () => {getMessages()}, 0);
}


async function getPeople() {
  loadedPeople = true;
  // console.log("load people");
}


async function getMessages() {
  loadedMessages = true;
  // console.log("load messages");
}

</script>